// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xVtbO","col":"styles_col__3sk7J","actions":"styles_actions__PjZ0L","conflict":"styles_conflict__2Yl9a"};